import React from 'react'
import { withIcon } from '../../withIcon'

function RewindIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M21.1724 6.15479C21.2861 6.15482 21.3981 6.18469 21.4966 6.24072C21.595 6.29681 21.6771 6.37709 21.7339 6.47412C21.7908 6.57132 21.82 6.68225 21.8198 6.79443V17.2056C21.82 17.3178 21.7908 17.4287 21.7339 17.5259C21.6771 17.6229 21.595 17.7032 21.4966 17.7593C21.3981 17.8153 21.2861 17.8452 21.1724 17.8452C21.0585 17.8452 20.9457 17.8155 20.8472 17.7593L12.6294 13.0845V17.2056C12.6295 17.3178 12.5993 17.4287 12.5425 17.5259C12.4856 17.6229 12.4037 17.7032 12.3052 17.7593C12.2066 17.8153 12.0948 17.8453 11.981 17.8452C11.8672 17.8451 11.7552 17.8154 11.6567 17.7593L2.50439 12.5532C2.40586 12.4972 2.32398 12.4159 2.26709 12.3188C2.21038 12.222 2.18026 12.1123 2.18018 12.0005C2.18018 11.8885 2.21029 11.7782 2.26709 11.6812C2.32398 11.5841 2.40586 11.5028 2.50439 11.4468L11.6567 6.24072C11.7552 6.18459 11.8672 6.15487 11.981 6.15479C12.0948 6.15474 12.2066 6.18467 12.3052 6.24072C12.4036 6.29676 12.4856 6.37711 12.5425 6.47412C12.5993 6.57132 12.6295 6.68225 12.6294 6.79443V10.9146L20.8472 6.24072C20.9457 6.18454 21.0585 6.15483 21.1724 6.15479Z" fill={color}/>
    </svg>
  )
}

export default withIcon(RewindIcon)
